<template>
  <section
    class="bg-black lg:h-screen-without-header lg:flex lg:flex-row-reverse"
  >
    <template v-if="blockData">
      <div
        class="py-20 px-3 space-y-4 lg:w-1/2 lg:flex lg:flex-col lg:justify-center lg:px-30"
      >
        <div
          v-if="blockData?.title"
          class="ui-h1 text-white text-center lg:text-left"
          v-html="blockData?.title"
        />
        <div
          v-if="blockData?.text"
          class="text-white text-base text-center lg:text-left"
          v-html="blockData?.text"
        />
      </div>
      <div class="lg:h-full lg:w-1/2">
        <UiLazyImg
          class="h-full w-full"
          :src="blockData?.file?.url"
          :src-mobile="blockData?.fileMobile?.url"
          :alt="blockData?.title"
          cover
        />
      </div>
    </template>
  </section>
</template>

<script setup lang="ts">
import { BlockSliderContent, BlockSliderSlide } from "ecom-types";

const props = defineProps<{ data: BlockSliderContent }>();

const blockData = computed<BlockSliderSlide | undefined>(() => {
  const [content] = props.data.slides;

  if (!content) return;

  return content;
});
</script>
